<template>
    <router-view/>
</template>

<script>
    export default {
        name: "OnlineServices",
    }
</script>

<style scoped>

</style>